import { get as _get } from "lodash";
import api from "../../helpers/api";

export const doGetClientTemplateList = (variables) => {
  return api().options("/client/get_template", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Client Templates list fetched successfully."),
      data: _get(res, "data", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "data.responseMessage", "Something went wrong while fetching client templates list."),
      data: {},
    };
  });
};

export const getMasterColumnLists = () => {
  return api().get("/client/template_field_lookup").then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Funnel Fuel master field list fetched successfully."),
      data: _get(res, "data", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching master field list."),
      data: {},
    };
  });
}

export const getClientTemplateDetailsById = (templateId) => {
  return api().get(`/client/template_detail/${templateId}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Template details fetched successfully."),
      data: _get(res, "data", {}),
    }
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching template details."),
      data: {},
    };
  });
}

export const createOrUpdateTemplate = (variables) => {
  return api().post("/client/add_update_template_detail", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Client template saved successfully."),
      data: _get(res, "data", null),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while saving client template."),
      data: null,
    };
  });
}

export const uploadClientTemplateHeaders = (variables) => {
  return api().post("/upload/client_template/headers", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "File uploaded successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while uploading the file."),
      data: {},
    };
  });
};

export const deleteClientTemplate = (templateId) => {

  return api().delete(`/client/template/${(templateId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Client template deleted successfully."),
      data: _get(res, "data", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "data.responseMessage", "Something went wrong while deleting client template."),
      data: {},
    };
  });
};
